import React from "react";
import styled from "styled-components";
import Icon from "./Icon";

type SvgProps = {
  color: string;
  position?: string; 
}

const Svg = styled(Icon)<SvgProps>`
  width: 21px;
  height: 20px;
  /* position: absolute; */
  top: 1rem;
  right: 1rem;
  fill: #999999;
  cursor: pointer;
  &:hover{
    fill: ${props => props.color};
  }
  @media (max-width: ${props => props.theme.breakpoints.md}){ 
    right: 1.8rem;
  }
  ${(props) => {
    if (typeof props.position !== "undefined") {
      return `position: ${props.position};`
    }
    return ''
  }}
`;
type CloseProps = {
  color: string;
  position?: string; 
  onClick: () => void;
};

export const Close: React.FC<CloseProps> = (props) => {
  return (
    <Svg
      color={props.color}
      onClick={props.onClick}
      position={props.position}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.7377 2.92929C15.848 1.03956 13.3396 0 10.667 0C7.99443 0 5.48602 1.03956 3.59628 2.92929C1.70655 4.81902 0.666992 7.32744 0.666992 10C0.666992 12.6726 1.70655 15.181 3.59628 17.0707C5.48602 18.9604 7.99443 20 10.667 20C13.3396 20 15.848 18.9604 17.7377 17.0707C19.6274 15.181 20.667 12.6726 20.667 10C20.667 7.32744 19.6274 4.81902 17.7377 2.92929ZM16.9338 16.2668C15.2587 17.9419 13.0323 18.8636 10.667 18.8636C8.30167 18.8636 6.07524 17.9419 4.40016 16.2668C0.94477 12.8114 0.94477 7.18855 4.40016 3.73316C6.07524 2.05808 8.30167 1.13636 10.667 1.13636C13.0323 1.13636 15.2587 2.05808 16.9338 3.73316C20.3892 7.18855 20.3892 12.8114 16.9338 16.2668Z" />
      <path d="M15.0735 5.59342C14.8504 5.37036 14.4927 5.37036 14.2696 5.59342L10.6669 9.19612L7.06425 5.59342C6.84119 5.37036 6.48344 5.37036 6.26038 5.59342C6.03732 5.81649 6.03732 6.17423 6.26038 6.3973L9.86307 9.99999L6.26038 13.6027C6.03732 13.8257 6.03732 14.1835 6.26038 14.4066C6.36981 14.516 6.51711 14.5749 6.66021 14.5749C6.80331 14.5749 6.95062 14.5202 7.06004 14.4066L10.6627 10.8039L14.2654 14.4066C14.3749 14.516 14.5222 14.5749 14.6653 14.5749C14.8126 14.5749 14.9557 14.5202 15.0651 14.4066C15.2882 14.1835 15.2882 13.8257 15.0651 13.6027L11.4708 9.99999L15.0735 6.3973C15.2966 6.17423 15.2966 5.81649 15.0735 5.59342Z" />
    </Svg>
  );
};
